import React, { Component } from 'react';
import { CourseActions } from 'actions';
import { CourseStore, AuthStore } from 'stores';
import Course from 'components/Route/Course';
import { mixin, RefluxMixin } from 'Util';
import shallowEqual from 'shallowequal';
import AppPage from 'components/AppPage';
import Loader from 'components/Material/Loader';

class CoursePreviewContainer extends mixin(RefluxMixin, Component) {

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    let params = this.props.routeParams;
    if (params.ownerSlug && params.courseSlug) {
      CourseActions.findBySlug(params.ownerSlug, params.courseSlug, true);
    }
  }

  listenToStores() {
    this.listenToStore(CourseStore);
    this.listenToStore(AuthStore);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !shallowEqual(this.state, nextState) ||
      !shallowEqual(this.props, nextProps)
    );
  }

  componentWillReceiveProps(nextProps) {
    const oldParams = this.props.params;
    const newParams = nextProps.params;
    if (!shallowEqual(oldParams, newParams)) {
      if (
        newParams.ownerSlug !== oldParams.ownerSlug ||
        newParams.courseSlug !== oldParams.courseSlug
      ) {
        CourseActions.findBySlug(newParams.ownerSlug, newParams.courseSlug);
      }
    }
  }

  render() {
    const { course } = this.state;
    const params = this.props.routeParams;
    if (
      !course.toc ||
      params.ownerSlug !== course.ownerSlug ||
      params.courseSlug !== course.slug
    ) {
      return (
        <AppPage style={{ paddingTop: 0 }}>
          <Loader />
        </AppPage>
      );
    }
    return (
      <Course
        course={this.state.course}
        params={this.props.params}
        router={this.props.router}
      >
        {this.props.children}
      </Course>
    );
  }
}

export default CoursePreviewContainer;



// WEBPACK FOOTER //
// ./src/js/components/Route/Course/CoursePreviewContainer.js